import {AnyAction, isAnyOf} from '@reduxjs/toolkit'
import {CALL_HISTORY_METHOD, LOCATION_CHANGE} from 'redux-first-history'

import {APIStatus, OrderPhase, OrderPhaseType, UserAuthStatus} from '@web/core/constants'
import {ROUTER_ORDER_POP_UP} from '@web/core/routes'
import {getChannelType, examineUrlSafety} from '@web/helpers/path'
import makeSlice from '@web/slices/common/sliceMaker'
import {LocationChangeAction} from '@web/slices/router'

import {initOrderSheetByAPI} from '../../actions'

/** route action 일치 검사 */
const routerActionMatcher = (action: AnyAction) => [CALL_HISTORY_METHOD, LOCATION_CHANGE].includes(action.type)
const isFetchingAction = isAnyOf(initOrderSheetByAPI.pending)
const isResolvedAction = isAnyOf(initOrderSheetByAPI.fulfilled)
const isRejectedAction = isAnyOf(initOrderSheetByAPI.rejected)

/** orderPhase 정보로 변환 */
const convertOrderPhaseType = (orderPhase: string): Maybe<OrderPhaseType> => {
    switch (orderPhase) {
        case 'checkout':
            return OrderPhase.CHECKOUT
        case 'result':
            return OrderPhase.RESULT
        default:
            return null
    }
}

/**
 * url param 으로부터 orderState 정보를 가져오는 함수
 */
const getOrderPhase = (location: Location = window.location): Maybe<OrderPhaseType> => {
    const urlRegex = /\/order\//
    const {pathname} = location
    const orderPhase = pathname.replace(urlRegex, '').split('/')[0] ?? ''

    return convertOrderPhaseType(orderPhase)
}

const commonSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {orderSheetId, backUrl, language}}) => {
                state.seqID = orderSheetId
                state.backUrl = examineUrlSafety(backUrl, '') || null
                state.scene = APIStatus.RESOLVED
                state.language = language ?? 'ko'
                state.entry = getChannelType()
            })
            .addMatcher(isFetchingAction, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isResolvedAction, (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isRejectedAction, (state, {payload}) => {
                if (payload?.userAuthStatus === UserAuthStatus.ANONYMOUS) {
                    state.language = 'en'
                }
                state.scene = APIStatus.REJECTED
            })
            .addMatcher(routerActionMatcher, (state, {payload}: LocationChangeAction) => {
                // popup 은 기존 값을 유지
                if (!payload.location?.pathname.match(ROUTER_ORDER_POP_UP.MAIN)) {
                    // page 이동시 saleChannel 정보 수정
                    state.entry = getChannelType()
                    state.orderPhase = getOrderPhase()
                }
                if (payload.isFirstRendering) {
                    state.scene = APIStatus.IDLE
                }
            })
    },
})

export default commonSlice.reducer

export const actions = commonSlice.actions
